import { Timestamp } from '@firebase/firestore';
import { HOUR24_DATE_CONFIG } from '../global';

export class CarePlan {
    noticing: string;
    interpreting: string;
    responding: string;
    reflecting: string;
    lastUpdated: Timestamp;

    constructor(
        noticing?: string,
        interpreting?: string,
        responding?: string,
        reflecting?: string,
        lastUpdated?: Timestamp,
    ) {
        this.noticing = noticing ? noticing : '';
        this.interpreting = interpreting ? interpreting : '';
        this.responding = responding ? responding : '';
        this.reflecting = reflecting ? reflecting : '';
        this.lastUpdated = lastUpdated? lastUpdated : Timestamp.now();
    }

    toFirebase() {
        const obj = JSON.parse(JSON.stringify(Object.assign({}, this)));
        obj.lastUpdated = this.lastUpdated;

        return obj;
    }

    get lastUpdatedString() {
        return this.lastUpdated.toDate().toLocaleString([], HOUR24_DATE_CONFIG).replace(',', ' @')
    }
}